<template>
  <div id="tramiteRecibido">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex xs12 >
          <h4 class="grey--text text--darken-1">
            <v-icon small color="primary">drag_indicator</v-icon> Trámite / Recibidos
          </h4>
        </v-flex>
      </v-layout>
      <v-card>
        <v-card-title>
          <!-- <v-select
            label="Tipo de trámite"
            :items="tipo_tramite"            
            item-value="id"
            item-text="descripcion"
          ></v-select> -->
          <v-spacer></v-spacer>
          <v-text-field
            v-model.trim="search"
            append-icon="search"
            label="Buscar"
            single-line
          >
          </v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :loading="loading"
          :items="recibidos"
          class="elevation-1"
          rows-per-page-text="Filas por página"
          no-data-text="No existen registros"
          no-results-text="Sin resultados"
          page-text="de"
          :rows-per-page-items="[10, 25, 50, 100, {'text': 'Todos', value: -1}]"
          v-bind:search="search"
          v-cloak
        >
          <template v-slot:items="props">
            <td>{{ props.item.id }}</td>
            <!-- <td>{{ props.item.codigo_tabla }}</td> -->
            <!-- <td>{{ props.item.nombre_tabla }}</td> -->
            <td>{{ props.item.flujo }}</td>
            <td>{{ props.item.tramite_tipo }}</td>
            <!-- <td>{{ props.item.obs }}</td> -->
            <td>{{ props.item.tarea_actual }}</td>
            <td>{{ props.item.proceso_tipo }}</td>
            <td>
              <span v-if="props.item.id_estado == 3"><v-chip small color="warning lighten-2">{{ props.item.tramite_estado }}</v-chip></span>
              <span v-else-if="props.item.id_estado == 4"><v-chip small color="red lighten-2">{{ props.item.tramite_estado }}</v-chip></span>
              <span v-else><v-chip small color="success lighten-2">{{ props.item.tramite_estado }}</v-chip></span>
              {{ props.item.fecha_estado | formatdate}}
            </td>
            <!-- <td>{{ props.item.fecha_estado | formatdate}}</td> -->
            <td>{{ props.item.plazo }}</td>
            <!-- <td>{{ props.item.fecha_vencimiento }}</td> -->
            <td>{{ props.item.nombre }}</td>
            <td>
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn
                    v-on="on"
                    icon
                    dark
                    color="info"
                    small
                    @click="detalleTramite(props.item)"
                    class="mx-1"
                  >
                    <v-icon small>view_list</v-icon>
                  </v-btn>
                </template>
                <span>Ver detalle</span>
              </v-tooltip>
              <v-tooltip bottom v-if="props.item.id_estado == 15 || props.item.id_estado == 4">
                <template v-slot:activator="{on}">
                  <v-btn
                    v-on="on"
                    icon
                    dark
                    color="success"
                    small
                    @click="recepcionTramite(props.item.id)"
                    class="mx-1"
                  >
                    <v-icon small>cloud_download</v-icon>
                  </v-btn>
                </template>
                <span>Recepcionar trámite</span>
              </v-tooltip>
              <v-tooltip bottom v-if="props.item.id_estado == 15 || props.item.id_estado == 4">
                <template v-slot:activator="{on}">
                  <v-btn
                    v-on="on"
                    icon
                    dark
                    color="primary"
                    small
                    @click="derivarTramite(props.item.id)"
                    class="mx-1"
                  >
                    <v-icon small>send</v-icon>
                  </v-btn>
                </template>
                <span>Derivar trámite</span>
              </v-tooltip>
              <v-tooltip bottom v-if="props.item.id_estado == 3">
                <template v-slot:activator="{on}">
                  <v-btn
                    v-on="on"
                    icon
                    dark
                    color="primary"
                    small
                    @click="atenderTramite(props.item.idflujo, props.item.id, props.item.ruta_formulario)"
                    class="mx-1"
                  >
                    <v-icon small>check</v-icon>
                  </v-btn>
                </template>
                <span>Atender trámite</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <v-dialog
      v-model="ddialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card dark color="primary">
          <v-toolbar-title>Detalle del trámite recibido</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="ddialog = false">Cerrar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-lg fluid class="pa-0">
            <v-card>
              <v-layout row wrap class="grey--text text--darken-1">
                <v-flex xs12 sm12 md6 class="py-0">
                  <v-list subheader class="py-0">
                    <v-list-tile avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>Número de trámite</v-list-tile-title>
                        <v-list-tile-sub-title>{{ detalle_recibido.id }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-list-tile avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>Trámite</v-list-tile-title>
                        <v-list-tile-sub-title>{{ detalle_recibido.flujo }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-list-tile avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>Tipo de trámite</v-list-tile-title>
                        <v-list-tile-sub-title>{{ detalle_recibido.tramite_tipo }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-list-tile avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>Código</v-list-tile-title>
                        <v-list-tile-sub-title>{{ detalle_recibido.codigo_tabla }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-list-tile avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>Nombre</v-list-tile-title>
                        <v-list-tile-sub-title>{{ detalle_recibido.nombre_tabla }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-list-tile avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>Usuario remitente</v-list-tile-title>
                        <v-list-tile-sub-title>{{ detalle_recibido.nombre }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                  </v-list>
                </v-flex>
                <v-flex xs12 sm12 md6 class="py-0">
                  <v-list subheader class="py-0">
                    <v-list-tile avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>Tarea actual</v-list-tile-title>
                        <v-list-tile-sub-title>{{ detalle_recibido.tarea_actual }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-list-tile avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>Tarea a ejecutar</v-list-tile-title>
                        <v-list-tile-sub-title>{{ detalle_recibido.proceso_tipo }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-list-tile avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>Plazo (días)</v-list-tile-title>
                        <v-list-tile-sub-title>{{ detalle_recibido.plazo }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-list-tile avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>Fecha vencimiento</v-list-tile-title>
                        <v-list-tile-sub-title>{{ detalle_recibido.fecha_vencimiento | formatdate }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-list-tile avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>Estado</v-list-tile-title>
                        <v-list-tile-sub-title>{{ detalle_recibido.tramite_estado }}, en fecha {{ detalle_recibido.fecha_estado | formatdate }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-list-tile avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>Observación</v-list-tile-title>
                        <v-list-tile-sub-title>{{ detalle_recibido.obs }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                  </v-list>
                </v-flex>
              </v-layout>
              <!-- <v-card-text class="grey--text text--darken-1">
                <v-layout row wrap>
                  <v-flex xs12 sm12 md6>
                    <v-layout row>
                      <v-flex xs6 sm4 md4 lg3>
                        <b>Número de trámite:</b>
                      </v-flex>
                      <v-flex xs6 sm8 md8 lg9>
                        <span>{{ detalle_recibido.id }}</span>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6 sm4 md4 lg3>
                        <b>Trámite:</b>
                      </v-flex>
                      <v-flex xs6 sm8 md8 lg9>
                        <span>{{ detalle_recibido.flujo }}</span>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6 sm4 md4 lg3>
                        <b>Tipo de trámite:</b>
                      </v-flex>
                      <v-flex xs6 sm8 md8 lg9>
                        <span>{{ detalle_recibido.tramite_tipo }}</span>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6 sm4 md4 lg3>
                        <b>Código:</b>
                      </v-flex>
                      <v-flex xs6 sm8 md8 lg9>
                        <span>{{ detalle_recibido.codigo_tabla }}</span>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6 sm4 md4 lg3>
                        <b>Nombre:</b>
                      </v-flex>
                      <v-flex xs6 sm8 md8 lg9>
                        <span>{{ detalle_recibido.nombre_tabla }}</span>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6 sm4 md4 lg3>
                        <b>Usuario remitente:</b>
                      </v-flex>
                      <v-flex xs6 sm8 md8 lg9>
                        <span>{{ detalle_recibido.nombre }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-layout row>
                      <v-flex xs6 sm4 md4 lg3>
                        <b>Tarea actual:</b>
                      </v-flex>
                      <v-flex xs6 sm8 md8 lg9>
                        <span>{{ detalle_recibido.tarea_actual }}</span>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6 sm4 md4 lg3>
                        <b>Tarea a ejecutar:</b>
                      </v-flex>
                      <v-flex xs6 sm8 md8 lg9>
                        <span>{{ detalle_recibido.proceso_tipo }}</span>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6 sm4 md4 lg3>
                        <b>Plazo (días):</b>
                      </v-flex>
                      <v-flex xs6 sm8 md8 lg9>
                        <span>{{ detalle_recibido.plazo }}</span>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6 sm4 md4 lg3>
                        <b>Fecha Vencimiento:</b>
                      </v-flex>
                      <v-flex xs6 sm8 md8 lg9>
                        <span>{{ detalle_recibido.fecha_vencimiento | formatdate }}</span>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6 sm4 md4 lg3>
                        <b>Estado:</b>
                      </v-flex>
                      <v-flex xs6 sm8 md8 lg9>
                        <span>{{ detalle_recibido.tramite_estado }}, en fecha {{ detalle_recibido.fecha_estado | formatdate }}</span>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6 sm4 md4 lg3>
                        <b>Fecha de Estado:</b>
                      </v-flex>
                      <v-flex xs6 sm8 md8 lg9>
                        <span>{{ detalle_recibido.fecha_estado | formatdate }}</span>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6 sm4 md4 lg3>
                        <b>Observación:</b>
                      </v-flex>
                      <v-flex xs6 sm8 md8 lg9>
                        <span>{{ detalle_recibido.obs }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text> -->
            </v-card>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="recepcionDialog" max-width="300px">
      <v-card>
        <v-card-title class="headline grey lighten-3">
          <span class="headline">Alerta</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="text-xs-center">
          <span
            :class="colorMsg+'--text text--darken-2 subheading'"
          >
            {{ mensajeCR }}
          </span>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="activeBtnCR"
            :loading="loadingCR"
            color="success darken-1"
            flat
            @click.native="confirmarRecepcion"
          >
            Aceptar
          </v-btn>
          <v-btn color="blue darken-1" flat @click.native="recepcionDialog = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="derivarDialog" scrollable max-width="300px">
      <v-card>
        <v-card-title class="headline grey lighten-3">
          <span class="headline">Alerta</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="text-xs-center">
          <v-form ref="form_usuario">
            <p
              :class="colorMsg+'--text text--darken-2 subheading'"
            >
              {{ mensajeCR }}
            </p>
            <v-autocomplete
              v-if="activeBtnCD"
              :items="usuarios"
              label="Usuario destinatario"
              item-text="nombre"
              item-value="id"
              v-model="usuario_destinatario"
              :rules="[v => !!v || 'Seleccione una opción']"
            ></v-autocomplete>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="activeBtnCD"
            :loading="loadingCD"
            color="success darken-1"
            flat
            @click.native="confirmarDerivado"
          >
            Aceptar
          </v-btn>
          <v-btn color="blue darken-1" flat @click.native="derivarDialog = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snack.state"
      top
      right
      :timeout="2500"
      :color="snack.color"
      :multi-line="snack.mode === 'multi-line'"
    >
      {{ snack.text }}
    </v-snackbar>
  </div>
</template>
<script>
/* eslint-disable no-console */
import Service from '../services/general';
import axios from 'axios';
export default {
  name: 'tramite-recibido',
  data() {
    return {
      search: '',
      headers: [
        { text: 'Nro', value: 'id', align: 'left', sortable: false },
        // { text: 'Código ', value: 'codigo_tabla' },
        // { text: 'Nombre ', value: 'nombre_tabla' },
        { text: 'Trámite ', value: 'flujo' },
        { text: 'Tipo de Trámite ', value: 'tramite_tipo' },
        // { text: 'Observación ', value: 'obs' },
        { text: 'Tarea Actual ', value: 'tarea_actual' },
        { text: 'Tarea Ejecutar ', value: 'tarea_ejecutar' },
        { text: 'Estado ', value: 'tramite_estado' },
        // { text: 'Fecha de Estado ', value: 'fecha_estado' },
        { text: 'Plazo (días) ', value: 'fecha_estado' },
        // { text: 'Fecha vencimiento ', value: 'fecha_vencimiento' },
        { text: 'Usuario Remitente ', value: 'fecha_estado' },
        // { text: 'Detalle ', value: 'detalle' },
        { text: 'Acciones', sortable: false, width: '200px' }
      ],
      loading: false,
      loadingCR: false,
      loadingCD: false,
      recibidos: [],
      detalle_recibido: {
        id: '',
        codigo_tabla: '',
        nombre_tabla: '',
        flujo: '',
        tramite_tipo: '',
        obs: '',
        tarea_actual: '',
        id_estado: '',
        tramite_estado: '',
        fecha_estado: '',
        plazo: '',
        fecha_vencimiento: '',
        nombre: '',
        proceso_tipo: '',
      },
      tramite_id: '',
      tipo_tramite: [],
      usuario_destinatario: '',
      usuarios: [],
      ddialog: false,
      recepcionDialog: false,
      derivarDialog: false,
      activeBtnCR: true,
      activeBtnCD: true,
      colorMsg: '',
      mensajeCR: '',
      dparams: {},
      snack: {
        state: false,
        color: 'success',
        mode: '',
        text: ''
      }
    };
  },
  mounted() {
    Service.removeTramiteId();//localStorage.removeItem('itr');
    this.dparams = Service.getParams();
    this.tipo_tramite = [
      {id: 1, descripcion: 'Ratificación'},
      {id: 2, descripcion: 'Ampliación'},
      {id: 3, descripcion: 'Cambio de Razón Social'},
      {id: 4, descripcion: 'Cambio de Domicilio'},
      {id: 5, descripcion: 'Cambio de derecho Propietario'},
      {id: 6, descripcion: 'Cierre del Centro de Capacitación'}
    ];
    if (this.dparams != null) {
      this.getRecibidos();
    }
  },
  methods: {
    getRecibidos() {
      this.loading = true;
      this.dparams.tipo = 2; //Recibido
      axios
        .post(Service.getServe() + 'tramite/lista', this.dparams, Service.getHeader())
        .then(response => {
          this.recibidos = response.data.entities;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.error('Error al cargar registros', error);
        });
    },
    detalleTramite(tramite) {
      this.detalle_recibido = tramite;
      this.ddialog = true;
    },
    recepcionTramite(tramite_id) {
      this.tramite_id = tramite_id;
      this.colorMsg = 'grey';
      this.mensajeCR = '¿Está seguro(a) de recepcionar el trámite ' + tramite_id + '?';
      this.recepcionDialog = true;
      this.activeBtnCR = true;
    },
    confirmarRecepcion() {
      this.loadingCR = true;
      this.dparams = Service.getParams();
      this.dparams.id = this.tramite_id
      axios
        .post(Service.getServe() + 'tramite/recibido/guardar', this.dparams, Service.getHeader())
        .then(response => {
          this.loadingCR = false;
          if (response.data.dato == true) {
            this.colorMsg = 'success';
            this.activeBtnCR = false;
            this.getRecibidos();
          } else {
            this.colorMsg = 'error';
            this.activeBtnCR = true;
          }
          this.mensajeCR = response.data.msg;
        })
        .catch(error => {
          this.loadingCR = false;
          this.activeBtnCR = true;
          console.error('No se pudo recibir el trámite', error);
        });
    },
    derivarTramite(tramite_id) {
      this.tramite_id = tramite_id;
      this.dparams.id = this.tramite_id
      this.colorMsg = 'grey';
      this.mensajeCR = '¿Está seguro(a) de derivar a otro responsable el trámite '+tramite_id+'?';
      this.loadingCD = false;
      this.activeBtnCD = true;
      this.derivarDialog = true;
      axios
      .post(Service.getServe() + 'tramite/recibido/derivar/usuario', this.dparams, Service.getHeader())
      .then(response => {
        this.usuarios = response.data.usuarios;
      })
      .catch(() => {
        console.log('Error, al obtener usuarios a derivar');
      });
    },
    confirmarDerivado() {
      this.loadingCD = true;
      this.dparams = Service.getParams();
      this.dparams.id = this.tramite_id;
      this.dparams.usuario_destinatario = this.usuario_destinatario;
      if (this.$refs.form_usuario.validate()) {
        axios
          .post(Service.getServe() + 'tramite/recibido/derivar/guardar', this.dparams, Service.getHeader())
          .then(response => {
            if (response.data.estado == 200) {
              this.colorMsg = 'success';
              this.activeBtnCD = false;
              this.getRecibidos();
            } else {
              this.colorMsg = 'error';
              this.activeBtnCD = true;
            }
            this.mensajeCR = response.data.msg;
            this.loadingCD = false;
          })
          .catch(error => {
            this.loadingCD = false;
            console.error('No se pudo recibir el trámite', error);
          });
      }
    },
    atenderTramite(flujo_id, tramite_id, ruta_formulario) {
      Service.setTramiteId(tramite_id);
      if (flujo_id == Service.getFlujoTipo().flujo_a) {// 16
        this.$router.push({ name: ruta_formulario });
      } else if (this.dparams.roluser == Service.rol().director) {
        axios
          .get(Service.getBase() + 'tramite/tipo/' + tramite_id, Service.getHeader())
          .then(response => {
            if (response.data.includes(8)) {
              this.$router.push({ name: 'tramite_apertura_subsede' });
            } else {
              this.$router.push({ name: ruta_formulario });
            }
          })
          .catch(() => {
            console.log('Error, al obtener tipo de trámite');
          });
      } else {
        this.$router.push({ name: ruta_formulario });
      }
    },
    toast(color, text) {
      this.snack.color = color;
      this.snack.text = text;
      this.snack.state = true;
    },
  }
};
</script>